<ng-container  *ngIf="dataConfig.modal === 'infoModal'">
    <div
    class="modal fade sns-modal-container"
    id="info-modal"
    tabindex="-1"
    data-backdrop="false"
    aria-labelledby="modal-label-modal-sns"
    [attr.aria-hidden]="!dataConfig.showModal"
    [ngClass]="dataConfig.showModal? 'show d-block': 'd-none'"
    (keydown)="onKeydownEvent($event, '#info-modal')"
    >
        <div class="modal-dialog sns-modal" role="document">
            <div role="dialog" aria-labelledby="scheduleNsaveContentTxt" class="modal-content sns-modal sns-modal__content py-4">
                <div class="modal-header sns-modal__header sns-modal--content-frequency__header px-4 py-3 ">
                    <button 
                    data-qa="abt-abtpopupxbtn-ss" 
                    (keydown.enter)="closeModal()" 
                    (click)="closeModal();analyticsSnsModalClick('ar:learn-more|close')" 
                    class="close sns-modal__close-btn mb-2 mr-1" 
                    data-dismiss="modal" 
                    aria-label="Close">
                        <span class="svg-icon svg-close-primary"></span>
                    </button>
                </div>
                <div class="sns-modal__body px-3">
                    <div class="sns-modal__body-top-container">
                        <div class="sns-modal__body-img-text-block d-flex flex-column align-items-center">
                            <div class="sns-modal__body-img">
                                <img aria-hidden="true" src="{{ dataConfig.contents?.featureLogo }}" alt="{{ dataConfig.contents?.snsText }} {{ dataConfig.contents?.snsOffer }}">
                                <span class="sns-modal__body-icon-container">
                                    <span class="sns-modal__body-sns-icon"></span>
                                </span>
                            </div>
                            <h1 id="scheduleNsaveContentTxt" class="title-lg mt-4 sns-modal__body-sns-text">
                                {{ dataConfig.contents?.snsText }} {{ dataConfig.contents?.snsOffer }}
                            </h1>
                            <h2 class="title-sm sns-modal__ada-color sns-modal--content-info__subheader text-center">
                                {{ dataConfig.contents?.featureSubHeader }}
                            </h2>
                        </div>
                    </div>
                    <div class="sns-modal__body-bottom-container">
                        <div *ngFor="let featurePoint of dataConfig.contents?.featurePoints" class="sns-modal--content-info__info-pill d-flex mt-4 mb-4">
                            <div class="mt-1 sns-modal__body-info-pill-chkmark">
                                <span class="sns-modal__body-info-pill-chkmark-svg"></span>
                            </div>
                            <div class="ml-3 sns-modal__body-info-pill-text-container d-flex flex-column align-items-start">
                                <span *ngIf="featurePoint.featurePointTitle" class="title-sm-bold">{{ featurePoint.featurePointTitle }}</span>
                                <span *ngIf="featurePoint.featurePointDescription" class="sns-modal__ada-color body-text">{{ featurePoint.featurePointDescription }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sns-modal__footer d-flex pt-4 align-items-center flex-column">
                    <div class="sns-modal__footer-btn">
                        <button class="btn btn-xl btn-primary" (click)="closeModal();analyticsSnsModalClick('ar:learn-more|got-it')" data-qa="abt-gtitbtn-ss">{{ dataConfig.contents?.featureButtonLabel }}</button>
                    </div>
                    <div class="sns-modal__footer-more-info d-flex flex-column align-items-center">
                        <a  role="link"
                            class="link-xs sns-modal__footer-faq-link"
                            href="{{ dataConfig.contents?.footerLink }}"
                            target=”_blank”
                            (click)="analyticsLinkClick('faqs')"
                            [attr.aria-label]="dataConfig.contents?.footerLinkText"
                        >
                        {{ dataConfig.contents?.footerLinkText }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="dataConfig.modal === 'freqModal'">
    <div
        class="modal fade sns-modal-container"
        id="frequency-modal"
        tabindex="-1"
        data-backdrop="false"
        aria-labelledby="modal-label-modal-sns"
        [attr.aria-hidden]="!dataConfig.showModal"
        [ngClass]="dataConfig.showModal? 'show d-block': 'd-none'"
        (keydown)="onKeydownEvent($event, '#frequency-modal')"
    >
        <div class="modal-dialog sns-modal" role="document">
            <form #frequencyForm="ngForm">
                <div role="dialog" aria-labelledby="frequencyHeaderTxt" class="modal-content sns-modal sns-modal__content py-4">
                    <div class="modal-header sns-modal__header sns-modal--content-frequency__header px-4 py-3 flex-column">
                        <div class="align-items-center d-flex mb-2">
                            <h1 class="modal-title w-100 text-center title-lg" id="frequencyHeaderTxt">
                                {{ dataConfig.contents?.frequencyHeader }}
                            </h1>
                            <button 
                            (keydown.enter)="closeModal()" 
                            (click)="closeModal();analyticsSnsModalClick('ar:frequency|close')" 
                            class="p-0 m-0 close sns-modal__close-btn" 
                            data-dismiss="modal" 
                            aria-label="Close">
                                <span class="svg-icon svg-close-primary"></span>
                            </button>
                        </div>
                        <h2 class="title-sm text-center">{{ dataConfig.contents?.frequencySubHeader }}</h2>
                    </div>
                    <div class="sns-modal__body sns-modal--content-frequency__body px-3">
                        <div class="sns-modal__body-frequency-container">
                            <ng-container *ngFor="let frequency of dataConfig.frequencies">
                                <div class="form-check radioButton__group pl-0">
                                    <input class="form-check-input radioButton__input radioButton--input d-block" 
                                        type="radio" name="frequency" 
                                        [attr.id]="'frequencyLabel' + frequency.count" 
                                        [value]="frequency.count" [(ngModel)]="formModel.frequency"
                                        (change)="clickFrequency(frequency.count)"/>
                                        <label class="form-check-label radioButton__label radioButton__label--md body-text" 
                                        [attr.for]="'frequencyLabel' + frequency.count">
                                        {{ "Every " + frequency.displayFrequency }}
                                    </label>
                                  </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="sns-modal__footer d-flex pt-4 align-items-center flex-column">
                        <div class="sns-modal__footer-btn">
                            <button
                                type="submit"
                                class="btn btn-xl btn-primary"
                                (click)="saveFrequency()"
                            >
                            {{ dataConfig.contents?.frequencyButtonLabel }}
                            </button>
                        </div>
                        <div class="sns-modal__footer-more-info d-flex flex-column align-items-center">
                            <a
                                role="link"
                                class="link-xs sns-modal__footer-faq-link"
                                href="{{ dataConfig.contents?.footerLink }}"
                                target=”_blank”
                                (click)="analyticsLinkClick('faqs')"
                                [attr.aria-label]="dataConfig.contents?.footerLinkText">
                                {{ dataConfig.contents?.footerLinkText }}
                            </a>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="dataConfig.modal === 'addRecurringModal'">
    <div
        class="modal fade sns-modal-container"
        data-backdrop="false"
        tabindex="-1"
        id="add-recurring-order-modal"
        aria-labelledby="modal-label-modal-sns"
        [attr.aria-hidden]="!dataConfig.showModal"
        [ngClass]="dataConfig.showModal? 'show d-block': 'd-none'"
        (keydown)="onKeydownEvent($event, '#add-recurring-order-modal')"
    >
        <div class="modal-dialog sns-modal" role="document">
            <div role="dialog" aria-labelledby="addRecurringHeaderTxt" class="modal-content sns-modal__content py-4">
                <div class="modal-header sns-modal__header sns-modal--content-frequency__header px-4 py-3 flex-column">
                    <div class="align-items-center d-flex mb-2">
                        <h1 class="modal-title w-100 text-center title-lg d-flex flex-start" id="addRecurringHeaderTxt">
                            {{ dataConfig.contents?.addRecurHeader }}
                        </h1>
                        <button 
                        (keydown.enter)="closeModal()" 
                        (click)="closeModal();analyticsSnsModalClick('ar:adding-to-recurring-order|close')" 
                        class="p-0 m-0 close sns-modal__close-btn" 
                        data-dismiss="modal" 
                        aria-label="Close">
                            <span class="svg-icon svg-close-primary"></span>
                        </button>
                    </div>
                    <h2 class="title-sm">{{ dataConfig.contents?.addRecurMessage }}</h2>
                </div>
                <div class="sns-modal__body px-3 pb-5">
                    <div class="sns-modal__info-box">
                        <div class="sns-modal__image-content float-left">
                            <img class="sns-modal__image" src="https://images.albertsons-media.com/is/image/ABS/{{dataConfig.product.id}}?$ecom-product-card-desktop-jpg$&defaultImage=Not_Available" alt="{{dataConfig.product.name}}" />
                        </div>
                        <div class="sns-modal__info-content float-left">
                            <div class="price-lg sns-modal__default">{{ dataConfig?.ecomDescription }}</div>
                            <div class="title-xs sns-modal__title mb-2"> {{dataConfig.product.name}}</div>
                            <div class="sns-modal__fulfill align-items-center d-flex background-color-secondary-200" *ngIf="dataConfig?.nextFulfillmentType?.length !== 0 && dataConfig?.nextFulfillmentDate?.length !== 0">
                                <div [ngClass]="dataConfig.nextFulfillmentType === 'DUG' ? 'svg-pickup' : 'svg-delivery'">
                                </div>
                                <div class="word-highlight-xs ml-1">{{dataConfig.nextFulfillmentType === 'dug' ? dataConfig.contents?.footerNextFulfillmentPickup : dataConfig.contents?.footerNextFulfillmentDelivery }}: {{dataConfig.nextFulfillmentDate | date: 'MMM. dd'}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="sns-modal__freq-content d-flex flex-column pt-4">

                        <quantity-stepper-al-v1
                            [ngClass]="'quantity-stepper-v3 quantity-stepper-v3--responsive-width'"
                            id="{{dataConfig.product.id}}"
                            [product]="dataConfig.product"
                            [calledBy]="'snsCheckoutFlowModal'"
                            [configObj]="configObj"
                            (updateQscQtyEmitter)="getUpdatedQty($event)"
                            [isAnyProductHasAddlInfo] = "true"
                            [isQscV2]="false" >
                        </quantity-stepper-al-v1>

                        <div class="input-field responsive-width">
                            <div class="input-field__wrapper text-dropdown-responsive" role="listbox">
                                <label for="week" class="input-field__float-label">
                                    <select id="week" 
                                    name="frequency" 
                                    placeholder=" " 
                                    aria-label="Frequency" 
                                    (change)="saveRecurringFreq($event.target.value)"
                                    >
                                        <option *ngFor="let frequency of dataConfig.frequencies"
                                        name="frequency"
                                        [id]="'frequencyLabel' + frequency.count"
                                        class="dropdown__group"
                                        [value]="frequency.count"
                                        >{{ "Every " + frequency.displayFrequency }}</option>
                                    </select>
                                    <span class="word-highlight-xs">Frequency</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sns-modal__footer d-flex pt-4 align-items-end flex-column">
                    <div class="sns-modal__button-box align-items-center d-flex">
                        <button class="btn btn-xl btn-primary" data-dismiss="modal" (click)="saveRecurringDetails();analyticsSnsModalClick('ar:subscribe-schedule-and-save-plp|subscribed')">{{ dataConfig.contents?.addRecurButtonLabel }}</button>
                        <button class="btn btn-xl btn-secondary sns-modal__button mr-3" data-dismiss="modal" (click)="closeModal();analyticsSnsModalClick('ar:adding-to-recurring-order|not-now')">{{ dataConfig.contents?.addRecurButtonNotNowLabel }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="dataConfig.modal === 'errorModal'">
    <div class="modal fade sns-modal-container" id="error-modal" role="dialog"
        aria-labelledby="modal-label-modal-sns" aria-hidden="true"
        tabindex="-1"
        data-backdrop="false"
        [attr.aria-hidden]="!dataConfig.showModal"
        [ngClass]="dataConfig.showModal? 'show d-block': 'd-none'"
        (keydown)="onKeydownEvent($event, '#error-modal')"
        >
        <div class="modal-dialog modal-dialog-centered sns-modal--content-error" role="document">
            <div class="modal-content sns-modal--content-error__content pt-3">
                <div class="modal-header sns-modal__header sns-modal--content-frequency__header px-4 py-3 ">
                    <div class="sr-only" id="errorModalDescription" *ngIf="dataConfig.errModalType === 'subscribe'">
                        We're unable to subscribe, due to a technical error, we're unable to add this item to a Schedule & Save subscription. Please try again later.
                    </div>
                    <div class="sr-only" id="errorModalDescription" *ngIf="dataConfig.errModalType === 'unsubscribe'">
                        We're unable to unsubscribe the item at this time. Please try again later. You may also cancel the item subscription within your Schedule & Save settings once the order is complete.
                    </div>
                    <button
                    (keydown.enter)="closeModal()" 
                    (click)="closeModal()" 
                    class="close sns-modal__close-btn mb-2 mr-1" 
                    data-dismiss="modal" 
                    aria-label="Close"
                    aria-describedby="errorModalDescription">
                        <span class="svg-icon svg-close-primary"></span>
                    </button>
                </div>
                <div class="d-flex flex-column align-items-center px-3 pb-4">
                    <div class="svg-caution mb-3"></div>
                    <h1 class="title-sm-bold text-center mb-3">
                        We&#39;re unable to {{dataConfig.errModalType}}
                    </h1>

                    <div class="sns-modal--content-error__container sns-modal__ada-color text-center d-flex align-items-center mt-2">
                        <ng-container *ngIf="dataConfig.errModalType === 'subscribe'">
                            Due to a technical error, we&#39;re unable to add this item to a Schedule & Save subscription. Please try again later.
                        </ng-container>

                        <ng-container *ngIf="dataConfig.errModalType === 'unsubscribe'">
                            We&#39;re unable to unsubscribe the item at this time. Please try again later. You may also cancel the item subscription within your Schedule & Save settings once the order is complete.
                        </ng-container>
                    </div>
                </div>
                <div class="d-flex p-4 justify-content-center">
                    <div class="sns-modal__footer-btn">
                        <button class="btn btn-xl btn-primary" (click)="closeModal()">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="dataConfig.modal === 'successModal'">
    <div
        class="modal fade sns-modal-container"
        id="success-modal"
        tabindex="-1"
        data-backdrop="false"
        aria-labelledby="modal-label-modal-sns"
        [attr.aria-hidden]="!dataConfig.showModal"
        [ngClass]="dataConfig.showModal? 'show d-block': 'd-none'"
        (keydown)="onKeydownEvent($event, '#success-modal')"
        >
        <div class="modal-dialog sns-modal" role="document">
            <div role="dialog" aria-labelledby="itemSchedHeaderTxt" class="modal-content sns-modal sns-modal__content py-4">
                <div class="modal-header sns-modal__header sns-modal--content-frequency__header px-4 py-3 flex-column">
                    <div class="align-items-center d-flex mb-2">
                        <h1 class="modal-title w-100 text-center title-lg" id="itemSchedHeaderTxt">
                            {{ dataConfig.contents?.itemSchedHeader }}
                        </h1>
                        <button 
                        (keydown.enter)="closeModal()" 
                        (click)="closeModal();analyticsSnsModalClick('ar:item-scheduled|close')" 
                        class="p-0 m-0 close sns-modal__close-btn" 
                        data-dismiss="modal" 
                        aria-label="Close">
                            <span class="svg-icon svg-close-primary"></span>
                        </button>
                    </div>
                </div>
                <div class="sns-modal__body sns-modal--content-success__body d-flex flex-column align-items-center px-2 pt-4 pb-5">
                    <h2 class="title-sm sns-modal__ada-color text-center mb-3 sns-modal--content-success__sub-header">
                        {{ dataConfig.contents?.itemSchedMessage }}
                    </h2>
                    <div class="sns-modal--content-success__image p-2 mb-4">
                        <img class="sns-modal__image" src="https://images.albertsons-media.com/is/image/ABS/{{dataConfig.productId}}?$ecom-product-card-desktop-jpg$&defaultImage=Not_Available" alt="{{dataConfig.product.name}}" />
                    </div>
                    <div class="sns-container d-flex flex-column align-items-center mt-2 p-3">
                        <span class="d-flex align-items-center justify-content-center sns-modal--content-success__repeat-icon background-color-secondary-200">
                            <span class="sns-modal__body-sns-icon"></span>
                        </span>
                        <div class="my-1 word-highlight-sm">{{dataConfig.nextFulfillmentType === 'dug' ? dataConfig.contents?.footerNextFulfillmentPickup : dataConfig.contents?.footerNextFulfillmentDelivery }}</div>
                        <div class="poppins-title-xl mb-4">{{dataConfig.nextFulfillmentType === 'dug' ? dataConfig.contents?.itemSchedNextFulfillmentDatePickupText : dataConfig.contents?.itemSchedNextFulfillmentDateDeliveryText}} {{dataConfig.productFulfillDate | date: 'MMM. dd'}}</div>
                        <div class="text-center pt-3 sns-modal--content-success__info">
                            <div class="body-text-sm sns-modal__ada-color">{{ dataConfig.contents?.itemSchedFrequencyText }} {{dataConfig.selectedFrequency === '1' ? 'week' : dataConfig.selectedFrequency + ' weeks'}}
                            </div>
                        </div>
                    </div>
                    <div class="sns-modal__terms sns-modal--content-success__terms d-flex flex-row mt-4">
                        <span class="body-text-sm sns-modal__ada-color">{{ dataConfig.contents?.itemSchedChangesText }} </span>
                        <a
                        role="link"
                        href="/schedule-and-save/manage"
                        class="link-sm sns-modal__default"
                        [attr.aria-label]="dataConfig.contents?.itemSchedChangesText + dataConfig.contents?.itemSchedManageLinkText"
                        (click)="analyticsLinkClick('manage')"
                        >{{ dataConfig.contents?.itemSchedManageLinkText }}</a>
                    </div>
                </div>
                <div class="sns-modal__footer d-flex pt-4 justify-content-center">
                    <div class="sns-modal__footer-btn">
                        <button 
                        class="btn btn-xl btn-primary"
                        data-dismiss="modal"
                        (click)="closeModal();analyticsSnsModalClick('ar:item-scheduled|continue-shopping')"
                        >{{ dataConfig.contents?.itemSchedButtonLabel }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
